export default {
  form: {
    header: {
      label: 'Koptekst',
      placeholder: 'Koptekst',
    },
    discount_badge: {
      label: 'Kortingsbadge',
      placeholder: '10 EUR',
    },
    description: {
      label: 'Beschrijving',
      placeholder: 'Beschrijving',
    },
    qr_code_header: {
      label: 'UI-vak koptekst',
      placeholder: 'UI-vak koptekst',
    },
    qr_code_description: {
      label: 'UI-vak beschrijving',
      placeholder: 'UI-vak beschrijving',
    },
    footer: {
      label: 'Voettekst',
      placeholder: 'Voettekst invoeren',
    },
    url_type: {
      label: 'URL',
      placeholder: 'URL selecteren',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Primaire kleur',
    },
    background_color: {
      label: 'Achtergrondkleur',
    },
    cover_image: {
      label: 'Omslagafbeelding',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Flyer laden mislukt',
  },
};
